import { render, staticRenderFns } from "./InvoiceDetailsView.vue?vue&type=template&id=c6aedb4c&"
import script from "./InvoiceDetailsView.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports